import { SHOW_ONSTREET_DELIVERY_INFOWINDOW,  HIDE_ONSTREET_DELIVERY_INFOWINDOW} from "./onstreetDeliveryInfoWindowReducer"

export const showOnstreetDeliveryInfoWindow = (obj) => ({
    type: SHOW_ONSTREET_DELIVERY_INFOWINDOW,
    payload: obj
})

export const hideOnstreetDeliveryInfoWindow = () => ({
    type: HIDE_ONSTREET_DELIVERY_INFOWINDOW,
})